import { render } from "./PurchaseModal.vue?vue&type=template&id=7509a536"
import script from "./PurchaseModal.vue?vue&type=script&lang=js"
export * from "./PurchaseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__